import React, { ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import deleteIcon from '../../../../img/icones/delete-red.svg';
import refreshIcon from '../../../../img/icones/refresh.svg';
import cartoucheHomme from '../../../../img/cartouche_homme.png';
import { Entity } from '../../../../network/api/types/compte/Entity';
import { InvitationDTO, REJECTED_STATUS } from '../../../../network/api/types/InvitationDTO';
import { dateFormatFromDate, hourFormatFromDate, timeBetweenDates } from '../../../../services/dateService';

interface MatchParams {
  entiteId: string;
}

type DateContent = {
  date: string,
  time: string,
};

export type TimeContent = {
  hours: string,
  minutes: string,
};

type Props = RouteComponentProps<MatchParams> & {
  invitation: InvitationDTO,
  clickDelete: () => void,
  clickRenew: () => void,
  entity?: Entity,
};

type State = {
  isExpired: boolean,
  isRejected: boolean,
};

class InvitationTile extends React.Component<Props, State> {
  state: State = {
    isExpired: false,
    isRejected: false,
  };

  componentDidMount() {
    this.updateIsExpired();
    this.updateIsRejected();
  }

  componentDidUpdate(prevProps) {
    if (this.props.invitation.expiryDate !== prevProps.invitation.expiryDate) {
      this.updateIsExpired();
    }
    if (this.props.invitation.status !== prevProps.invitation.status) {
      this.updateIsRejected();
    }
  }

  updateIsExpired = (): void => {
    const expiration = new Date(this.props.invitation.expiryDate);
    this.setState({ isExpired: Date.now() > expiration.getTime() });
  };

  updateIsRejected = (): void => {
    this.setState({ isRejected: this.props.invitation.status === REJECTED_STATUS });
  };

  getCreationDate = (): DateContent => {
    const creationDate = new Date(this.props.invitation.creationDate);
    return {
      date: dateFormatFromDate(creationDate),
      time: hourFormatFromDate(creationDate),
    };
  };

  getExpiryTime = (): TimeContent => {
    const expiryDate = new Date(this.props.invitation.expiryDate);

    return timeBetweenDates(expiryDate.getTime());
  };

  getFullName = (): string => `${this.props.invitation.firstName} ${this.props.invitation.lastName?.toUpperCase()}`;

  getStatusWordingKey = (): string => {
    if (this.state.isRejected) {
      return 'rejected';
    }
    if (this.state.isExpired) {
      return 'expired';
    }
    return 'sent';
  };

  render(): ReactNode {
    const isWarning = this.state.isExpired || this.state.isRejected;
    const { isRejected } = this.state;
    const { invitation } = this.props;
    return (
      <>
        <div className="rattachement-tile">
          <div className="manage-colaborator-tile manage-colaborator-tile--invitation">
            <div className="picture-container">
              <div className="picture">
                <img alt="Profile pic" src={cartoucheHomme} />
              </div>
            </div>
            <div className="personnal-information">
              <div className="name" title={this.getFullName()}>{this.getFullName()}</div>
              <div className="email" title={invitation.email}>{invitation.email}</div>
            </div>
            <div className="status-information">
              <div className={`status ${isWarning ? 'expired' : ''}`}>
                {I18n.t(`collaborators.invitation.${this.getStatusWordingKey()}`)}
              </div>
              <div className={`creation-date ${isWarning ? 'hidden' : ''}`}>
                {I18n.t('collaborators.invitation.creation', this.getCreationDate())}
              </div>
              <div className={`time-remaining ${isWarning ? 'hidden' : ''}`}>
                {I18n.t('collaborators.invitation.active', this.getExpiryTime())}
              </div>
            </div>
            <div className={`button-container ${isRejected ? 'hidden' : ''}`}>
              <button
                className="icon-button"
                type="button"
                onClick={this.props.clickRenew}
              >
                <img
                  className="refresh"
                  alt="button-delegate"
                  src={refreshIcon}
                />
              </button>
              <button
                className="icon-button"
                type="button"
                onClick={this.props.clickDelete}
              >
                <img
                  className="delete"
                  alt="button-delegate"
                  src={deleteIcon}
                />
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InvitationTile);
